import claimsServices from '@/modules/claims/services/jsonapi'

export default {
  get claims () {
    return claimsServices
  }
}
